export enum DeliveryMethod {
    Text = 'Text',
}
